<template>
  <Modal
    :title="title"
    :saving="saving"
    saving-text="Processing..."
    submit-btn-text="Edit Invoice"
    submit-btn-class="btn btn-sm btn-danger ml-auto"
    @submit="handleSubmit"
    @hide-modal="$emit('hide-modal')"
  >
    <div class="form-group mb-0">
      <WarningMessage>{{ warningMessage }}</WarningMessage>
      <TextArea
        v-model="reason"
        class="full-width"
        name="Reason"
        label="Please provide a reason for editing this invoice"
        :validation-errors="v$.$errors"
      >
      </TextArea>
      <div class="notice-message mt-1">
        <i class="far fa-circle-info mr-1"></i>
        <div>
          After an invoice is open for editing,
          <strong>changes to line items must be made through the quote.</strong>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import WarningMessage from "serviceshift-ui/components/General/WarningMessage.vue";
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import Modal from "@/components/Modal.vue";
import TextArea from "@/components/TextArea.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  components: {
    Modal,
    TextArea,
    WarningMessage
  },
  props: {
    invoice: {
      type: Object,
      default: null
    }
  },
  emits: ["hide-modal"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      reason: "",
      saving: false
    };
  },
  computed: {
    title() {
      if (!this.invoice) return "Edit Invoice";
      return `Edit Invoice #${this.invoice.invoice_id}`;
    },
    warningMessage() {
      return "Editing this invoice will require a new customer signature to be obtained.";
    }
  },
  validations() {
    return {
      reason: { required, $autoDirty: true }
    };
  },
  methods: {
    ...mapActions(["unapproveInvoice"]),
    async handleSubmit() {
      const isValid = await this.v$.$validate();
      if (!isValid) {
        return;
      }

      this.saving = true;
      try {
        await this.unapproveInvoice({
          link: this.invoice.links.invoice_break,
          reason: this.reason
        });
        window.notify.success(
          `Invoice #${this.invoice.invoice_id} is now editable.`
        );
        this.$emit("hide-modal");
        EventBus.$emit("invoice-unapproved");
        EventBus.$emit("refresh-job");
      } catch (error) {
        Sentry.captureException(error);
        console.error(error);
      }
      this.saving = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.notice-message {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 3px;
  background: var(--uranian-blue);

  i {
    font-size: 1.1em;
  }
}
</style>
